// import React, { Children } from "react";
import React, { useState, useCallback } from 'react';

const Modal = ({ isOpen, closeModal, currentPage, setCurrentPage, children, handleLogin, handlePageChange }) => {

  const forceUpdate = React.useReducer(() => ({}), {})[1]; // Force update hook

  const handlePageLogin = (page) => {
    setCurrentPage(page);
    forceUpdate();  // 状態変更後に強制的に再レンダリング
  };

  if (! isOpen) return null; 
  

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={closeModal}>X</button>
        <div className='logo'>Gold</div><div className='logo'>Coast Koala</div>
        {currentPage === "post_comp" ?(
          <>
          <div className='post__comp'>
            <span>投稿はMY PAGEよりいつでも編集・削除いただけます。</span>
            <span>募集が終了した際は、投稿の非表示への切り替えを忘れずにお願い致します。</span>
            <p>「有料枠に掲載する」に掲載するをチェックされた方には、GCkoala よりご登録のメールアドレス又はLNEにご案内を送らせていただきます。</p>
            <a href='/sharehouse'>一覧ページへ戻る</a>
            <a href='/mypage'>投稿を確認する</a>
          </div>
          </>
        ):currentPage === "edit_comp" ?(
          <>
          <h2 className='login__ttl'>編集が完了しました</h2>
          <div className='post__comp'>
            <span>投稿はMY PAGEよりいつでも編集・削除いただけます。</span>
            <span>募集が終了した際は、投稿の非表示への切り替えを忘れずにお願い致します。</span>
            <a href='/sharehouse'>一覧ページへ戻る</a>
            <a href='/mypage'>投稿を確認する</a>
          </div>
          </>
        ):currentPage === "404-login" ?(
          <>
            <div className='login__comp'>
              <span>ユーザー専用機能です</span>
              <p>画面右上のボタンよりログイン、または会員登録後こちらの機能をお使いいただけます。</p>
            </div>
          </>
        ): currentPage === "login" ? (
          <>
          <h2 className='login__ttl'>SIGN IN</h2>
          <div className='login__btn-wrap'>
            <div className='login__btn line' onClick={handleLogin}>
              <span>LINEでログイン</span>
              {/* <a><img src='/media/line_login.svg' /></a> */}
            </div>
            <div className='login__btn id' onClick={() => setCurrentPage("login_form")}>
              <span>IDでログイン</span>
            </div>
            <div className='login__btn up'>
              <h3>初めての方はこちら</h3>
              <span onClick={() => handlePageChange("creat_user")}>ユーザー登録する</span>
            </div>
          </div>
          </>
        ):null}
        {children}
      </div>
    </div>
  );
};

export default Modal;